import React from 'react';

import { useTheme } from '../../contexts/ThemeContext';

export type PaymentResultCoverVariant = 'success' | 'failed';

interface PaymentResultCoverProps {
  variant: PaymentResultCoverVariant;
  eyebrow?: string;
  title: string;
  subtitle: string;
}

const COVER_IMAGES: Record<PaymentResultCoverVariant, { light: string; dark: string }> = {
  success: {
    light: '/images/payment/payment-success-cover-light.png',
    dark: '/images/payment/payment-success-cover-dark.png',
  },
  failed: {
    light: '/images/payment/payment-failed-cover-light.png',
    dark: '/images/payment/payment-failed-cover-dark.png',
  },
};

/** Left marketing column — hero image with copy block below (not overlaid). */
const PaymentResultCover: React.FC<PaymentResultCoverProps> = ({
  variant,
  eyebrow = 'GoGrabJob',
  title,
  subtitle,
}) => {
  const { theme } = useTheme();
  const imageSrc = theme === 'dark'
    ? COVER_IMAGES[variant].dark
    : COVER_IMAGES[variant].light;

  return (
    <section
      className="payment-pin-split__proof-col"
      aria-label={title}
    >
      <div className="payment-pin-split__proof-inner">
        <div className="payment-pin-split__hero-group">
          <div className="payment-pin-split__hero-frame">
            <div className="payment-pin-split__hero-image-frame">
              <img
                key={imageSrc}
                src={imageSrc}
                alt={
                  variant === 'success'
                    ? 'Payment successful — credits ready on GoGrabJob'
                    : 'Payment failed — no charge completed on GoGrabJob'
                }
                className="payment-pin-split__hero-img"
                decoding="async"
              />
            </div>
          </div>
          <div className="payment-pin-split__hero-copy">
            <p className="payment-pin-split__hero-eyebrow">{eyebrow}</p>
            <h2 className="payment-pin-split__hero-title">{title}</h2>
            <p className="payment-pin-split__hero-sub">{subtitle}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PaymentResultCover;
